module.exports = __webpack_public_path__ + "img/Brick.ab17d3f5.svg";